import React, { Component } from 'react';
import logo from '../../img/rat-logo.png';
import $ from 'jquery';
import Script from 'react-load-script';
import { BrowserRouter as Router, Switch, Route, Link, browserHistory } from 'react-router-dom';

class Header extends Component {
    componentDidMount(){
      $('.menu-hamburger').on('click', function(){
        $('.menu-hamburger').toggleClass('open');
        $('.mobile-menu').toggleClass('active');
    });
      $('.mobile-menu a').on('click', function(){
        $('.mobile-menu').removeClass('active');
        $('.menu-hamburger').removeClass('open');
    });
        }

	render() {
    return (
        <div>
        <div className="mobile-menu">
        <ul>
                        
                        <li><Link to={{pathname: '/'}} className="link-text">HOME</Link></li>
                        <li><Link to={{pathname: '/about'}} className="link-text">ABOUT</Link></li>
                        <li><Link to={{pathname: '/directors'}} className="link-text">DIRECTORS</Link></li>
                        <li><Link to={{pathname: '/services'}} className="link-text">SERVICES</Link></li>
                        <li><Link to={{pathname: '/gallery'}} className="link-text">GALLERY</Link></li>
                        <li><Link to={{pathname: '/social_media'}} className="link-text">SOCIAL MEDIA</Link></li>
                        <li><Link to={{pathname: '/contact'}} className="link-text">CONTACT</Link></li>
                        <li className= "phone"><a href="tel:9029500400" className="link-text i_outer" target="_blank"><img src={require('../../img/phone_icon.png')} alt="" />9029500400</a></li>
                        <li className= "inline-li"><a href="https://www.facebook.com/ratfilms/" className="i_outer" target="_blank"><img src={require('../../img/social_fb.png')} alt="" /></a></li>
                        <li className= "inline-li"><a href="https://plus.google.com/u/0/108590595508719487376" className="i_outer" target="_blank"><img src={require('../../img/social_google.png')} alt="" /></a></li>
                        <li className= "inline-li"><a href="https://twitter.com/RATFilmsIndia" className="i_outer" target="_blank"><img src={require('../../img/social_twitter.png')} alt="" /></a></li>
                        <li className= "inline-li"><a href="https://www.youtube.com/channel/UCXjbBkM1dQ-A8Oq16n6FFLg" className="i_outer" target="_blank"><img src={require('../../img/social_youtube.png')} alt="" /></a></li>
                            
                    </ul> 
    </div>
		<header>
			<div className="container">
            <div className="menu-hamburger">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className="logo">
                <a href="http://ratfilms.in"><img src={logo} alt="" /></a> 
            </div>
            <div className="links-sec">
                <div className="media-links dtd-brdr-bottom">
                    <ul>
                        <li><a href="tel:9029500400" className="link-text i_outer" target="_blank"><img src={require('../../img/phone_icon.png')} alt="" />9029500400</a></li>
                        <li><a href="https://www.facebook.com/ratfilms/" className="i_outer" target="_blank"><img src={require('../../img/social_fb.png')} alt="" /></a></li>
                        <li><a href="https://plus.google.com/u/0/108590595508719487376" className="i_outer" target="_blank"><img src={require('../../img/social_google.png')} alt="" /></a></li>
                        <li><a href="https://twitter.com/RATFilmsIndia" className="i_outer" target="_blank"><img src={require('../../img/social_twitter.png')} alt="" /></a></li>
                        <li><a href="https://www.youtube.com/channel/UCXjbBkM1dQ-A8Oq16n6FFLg" className="i_outer" target="_blank"><img src={require('../../img/social_youtube.png')} alt="" /></a></li>
                    </ul>
                </div>
                <div className="menu-bar">
                    <ul>
                        <li><Link to={{pathname: '/'}} className="link-text">HOME</Link></li>
                        <li><Link to={{pathname: '/about'}} className="link-text">ABOUT</Link></li>
                        <li><Link to={{pathname: '/directors'}} className="link-text">DIRECTORS</Link></li>
                        <li><Link to={{pathname: '/gallery'}} className="link-text">GALLERY</Link></li>
                        <li><Link to={{pathname: '/services'}} className="link-text">SERVICES</Link></li>
                        <li><Link to={{pathname: '/social_media'}} className="link-text">SOCIAL MEDIA</Link></li>
                        <li><Link to={{pathname: '/contact'}} className="link-text">CONTACT</Link></li>
                    </ul>
                </div>
            </div>
        </div>
			
		</header>
        </div>

		
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/common/header.js